import { render, staticRenderFns } from "./ImageWithLayers.vue?vue&type=template&id=6e5bcfa5&scoped=true"
import script from "./ImageWithLayers.vue?vue&type=script&lang=js"
export * from "./ImageWithLayers.vue?vue&type=script&lang=js"
import style0 from "./ImageWithLayers.vue?vue&type=style&index=0&id=6e5bcfa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5bcfa5",
  null
  
)

export default component.exports